import { services } from '@repo/ui/lib/api/services';
import type { MenuConfig } from '@repo/types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const menuConfigQueryKey = ['settings', 'menu-config'] as const;

/** Visibilité des menus par rôle : lue par la barre latérale et le contrôle d'accès des pages. */
export const useMenuConfig = () =>
  useQuery<MenuConfig>({
    queryKey: menuConfigQueryKey,
    queryFn: () => services.settings.getMenuConfig(),
    staleTime: 5 * 60 * 1000,
  });

export const useUpdateMenuConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config: MenuConfig) => services.settings.updateMenuConfig(config),
    onSuccess: (config) => queryClient.setQueryData(menuConfigQueryKey, config),
  });
};
